import * as React from 'react';

export function IconInfrastructure() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 80 80">
      <path fill="#0468FF" fillOpacity=".15" d="M0 16l24-8 16 8 24-8v64l-24 8-16-8-24 8V16z" />
      <path fill="#0468FF" d="M32 44v-8h40v8l8 12v4h-4v20H28V60h-4v-4l8-12z" />
      <path fill="#fff" d="M34 64h20v12H34zM32 42h40v2H32zM60 64h12v16H60z" />
    </svg>
  );
}
